'use strict';

var Sugar = require('sugar-core'),
    dateIsValid = require('./internal/dateIsValid');

Sugar.Date.defineInstance({

  'isValid': function(date) {
    return dateIsValid(date);
  }

});

module.exports = Sugar.Date.isValid;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isValid.js
// module id = 563
// module chunks = 0